module.exports = __webpack_public_path__ + "img/safe-home.a0944b06.svg";